export const API_ROOT = process.env.REACT_APP_HOST + process.env.REACT_APP_API_ROOT

export const PATH = {
    GET_BASIC_INFO: `${API_ROOT}/dashboard-basic-data`,
    GET_ACTIVITY_CATEGORIES: `${API_ROOT}/activity/allowedactivitycategories`, 
    GET_USER_INFO: `${API_ROOT}/user`,
    GET_ACTIVITIES: `${API_ROOT}/activities`,
    GET_ACTIVITY: `${API_ROOT}/activity`,
    POST_ACTIVITY: `${API_ROOT}/activity`,
    FAVORITE_ACTIVITY: (id) => `${API_ROOT}/activity/${id}/favorite`,
    PUT_ACTIVITY: (id) => `${API_ROOT}/activity/${id}`,
    ATTACHMENTS: (ids = []) => {const _ids = ids.join('-');return `${API_ROOT}/attachment/url/${_ids}`},
    ATTACHMENT: `${API_ROOT}/attachment`,
    ATTACHMENT_DELETE: (id) => `${API_ROOT}/attachment/${id}`,
    GET_ALL_REGISTERS: (id) => `${API_ROOT}/activity/${id}/registers/export`,
    ADD_GET_FEEDBACK: (id) => `${API_ROOT}/activity/${id}/feedback`,
    CANCEL_REGISTER: (id) => `${API_ROOT}/activity/${id}/unregister`,
    DELETE_REGISTER: (id) => `${API_ROOT}/registers/${id}`,
    GET_EMAIL_RECEIVERS: () => `${API_ROOT}/email/recipients`,
    SEND_EMAIL_NOTIFICATION: (activityId) => `${API_ROOT}/notification/${activityId}/email`,
    POST_FAVORITE: (id) => `${API_ROOT}/activity/${id}/favorite`,
    GET_DASHBOARD_BASIC_DATA: `${API_ROOT}/dashboard-basic-data`,
    DELETE_ACTIVITY: (activityId) => `${API_ROOT}/activity/${activityId}/delete`,
}

export const LOGOUT_URL = process.env.REACT_APP_LOGOUT_URL;
